import React, { useState } from "react";
import Table from "../../components/table";
import AgentProfile from "./agents/agent-profile";
import { TailSpin } from "react-loader-spinner";

const AgentTable = ({ data }: any) => {
  const [selectedAgent, setSelectedAgent] = useState<any | null>(null);
  const [isLoading] = useState(false);
  const columns = [
    { header: "", accessor: "profilePhoto" },
    { header: "Name", accessor: "fullname" },
    { header: "Email Address", accessor: "email" },
    { header: "Phone No", accessor: "phone" },
    { header: "Date Added", accessor: "created_at" },
    { header: " ", accessor: "id" },
  ];

  const handleUserClick = (id: string) => {
    const agent = data?.find((a: any) => a.id === id || a._id === id);
    setSelectedAgent(agent || null);
  };

  const handleCloseModal = () => {
    setSelectedAgent(null);
  };

  return (
    <div className="rounded-md py-3 px-3 bg-white border border-[#fff] mt-10 w-[95%] pt-5 ">
      <div className="flex justify-between">
        <p className="text-[18px] font-semibold">All Accounts</p>
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <TailSpin color="skyblue" />
        </div>
      ) : data?.length > 0 ? (
        <Table
          columns={columns}
          data={data}
          selectedUserId={null}
          onUserClick={handleUserClick}
        />
      ) : (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-500 text-lg">No data available</p>
        </div>
      )}

      {selectedAgent && (
        <AgentProfile
          visible={!!selectedAgent}
          handleClose={handleCloseModal}
          id={selectedAgent.id || selectedAgent._id}
          agentId={selectedAgent._id}
        />
      )}
    </div>
  );
};

export default AgentTable;
